import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reverse";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _toArray from "@babel/runtime-corejs3/helpers/toArray";
import React from 'react';
import { GridLayout } from './GridLayout';
import { childrenToArray } from './childrenToArray';
export const mergeColumnsToFirst = (children, newColumnsNumber) => {
  var _context;
  const numberOfColumnsToMerge = children.length - newColumnsNumber;
  const _children = _toArray(children),
    firstColumn = _children[0],
    restChildren = _sliceInstanceProperty(_children).call(_children, 1);
  const columnsToMerge = _spliceInstanceProperty(restChildren).call(restChildren, 0, numberOfColumnsToMerge);
  const newFirstColumn = React.cloneElement(firstColumn, undefined, [...childrenToArray(firstColumn.props.children), ..._flatInstanceProperty(_context = _mapInstanceProperty(columnsToMerge).call(columnsToMerge, column => childrenToArray(column.props.children))).call(_context)]);
  return [newFirstColumn, ...restChildren];
};
export const mergeColumnsToLast = (children, newColumnsNumber) => {
  var _context2, _context3;
  return _reverseInstanceProperty(_context2 = mergeColumnsToFirst(_reverseInstanceProperty(_context3 = [...children]).call(_context3), newColumnsNumber)).call(_context2);
};
export const stackColumnsToFirst = (children, newColumnsNumber) => {
  const numberOfColumnsToStack = children.length - newColumnsNumber;
  const childrenCopy = [...children];
  const columnsToStack = _spliceInstanceProperty(childrenCopy).call(childrenCopy, 0, numberOfColumnsToStack + 1);
  return [React.createElement(GridLayout, {
    id: _mapInstanceProperty(columnsToStack).call(columnsToStack, column => column.props.id).join('-')
  }, _mapInstanceProperty(columnsToStack).call(columnsToStack, column => React.cloneElement(column, {
    key: column.props.id
  }))), ...childrenCopy];
};
export const stackColumnsToLast = (children, newColumnsNumber) => {
  var _context4, _context5;
  return _reverseInstanceProperty(_context4 = stackColumnsToFirst(_reverseInstanceProperty(_context5 = [...children]).call(_context5), newColumnsNumber)).call(_context4);
};